/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable camelcase */
import dutchMessages from 'ra-language-dutch'
import { StringMap } from 'react-admin'

export const i18nDutch: StringMap = {
  ...dutchMessages,
  dashboard: {
    greeting: {
      morning: 'Goedemorgen',
      afternoon: 'Goedemiddag',
      evening: 'Goedenavond',
    },
    description: 'Welkom bij xxllnc Samenwerkingen.',
    descriptionAdmin: 'Welkom bij xxllnc Samenwerkingen.',
  },
  resources: {
    collaborations: {
      list: 'Samenwerkingen',
      edit: 'Samenwerking aanpassen',
      create: 'Samenwerking starten',
      title: 'Samenwerking',
      contactPersonCompetentAuthority: 'Contactpersoon bevoegde gezag',
      sourceSystem: 'Bron systeem',
      caseDescription: 'Nieuwe samenwerking starten voor zaaknummer %{name}',
      status: {
        INITIALISATIE: 'In afwachting',
        OPEN: 'Open',
        GESLOTEN: 'Gesloten',
      },
      requestStatus: {
        OPEN: 'Open',
        IN_BEHANDELING: 'In behandeling',
        GEWEIGERD: 'Geweigerd',
        INGETROKKEN: 'Ingetrokken',
        GEREEDGEMELD: 'Gereed gemeld',
        GEREED: 'Gereed',
      },
      confidentiality: {
        SV: 'Vertrouwelijk',
        RV: 'Strikt vertrouwelijk',
      }
    },
    notificationConfigurations: {
      list: 'Notificatie configuraties',
      create: 'Notificatie configuratie aanmaken',
      edit: 'Notificatie configuratie aanpassen',
    },
    requests: {
      editStatus: 'Status aanpassen',
      editStatusDescription: 'Hier kun je de status en eventueel de melding van het actieverzoek aanpassen.',
      statusWarning: 'Let op: Er zijn beperkingen op het aanpassen van de status van een actieverzoek. ' +
      'Afhankelijk of je zender of ontvanger bent en de huidige status zijn bepaalde statusen niet beschikbaar. ' +
      'Een actieverzoek kan niet worden aangepast als de status GEREED, GEWEIGERD of INGETROKKEN is.',
    },
  },
  filters: {
    title: 'Filters',
    status: 'Status',
    all: 'Alles',
  },
  show: {
    details: 'Samenvatting',
    partners: 'Ketenpartners',
    documents: 'Documenten',
    requests: 'Actieverzoeken',
    notifications: 'Notificaties',
    audit: 'Audit log',
    noDocuments: 'Er zijn nog geen documenten toegevoegd',
    synced: 'Gesynchroniseerd',
    notSynced: 'Niet gesynchroniseerd',
  },
  data: {
    createdAt: 'Aangemaakt op',
    nummerBinnenSysteem: 'Zaaknummer',
    closed: 'Gesloten',
    globaleLocatie: 'Globale locatie van het verzoek',
    sourceRequest: 'Bron verzoek',
    oloVerzoeknummer: 'OLO-verzoeknummer',
    oloRequestNumberHelperText: 'Het nummer van het OLO-verzoek. ' +
    'Kan niet worden gebruikt i.c.m. Verzoeknummer. ' +
    'Als het ingevuld is, moet bron verzoek OLO zijn of leeg worden gelaten.',
    requestNumberHelperText: 'Verzoeknummer van de samenwerking. ' +
    'Kan niet worden gebruikt i.c.m. OLO-verzoeknummer. ' +
    'Als het ingevuld is, moet bron verzoek DSO_LV zijn of leeg worden gelaten.',
    deadline: 'Deadline',
    productCode: 'Productcode',
    explanation: 'Toelichting',
    reactions: 'Reacties',
    postReaction: 'Reactie plaatsen',
    charactersLeft: 'Nog ruimte voor %{count} karakters',
    addRequest: 'Nieuw actieverzoek aanmaken',
    addRequestSubtitle: 'Hier kun je een nieuw actieverzoek toevoegen aan de samenwerking.',
    linkDocument: 'Document koppelen',
    linkDocumentDsoOnly: 'Alleen documenten die in de DSO-samenwerking beschikbaar zijn kunnen aan een actieverzoek worden gekoppeld.',
    requestStatusReadonly: 'Documenten kunnen niet gewijzigd worden in de huidige status van dit actieverzoek.',
    addDocument: 'Document toevoegen',
    addPartner: 'Ketenpartner toevoegen',
    complete: 'Afronden',
    editSamenwerking: 'Samenwerking bewerken',
    editSamenwerkingSubtitle: 'Pas de gegevens van de samenwerking aan.',
    transferSamenwerking: 'Samenwerking overdragen',
    transferTo: 'Overdragen aan organisatie',
    transferWarning: 'Let op: het overdragen van een samenwerking is onomkeerbaar. ' +
    'Na de overdracht ben je niet langer de initiatiefnemer en heb je de samenwerking niet meer zelf in beheer.',
    confirmTransferSamenwerking: 'Weet je zeker dat je deze samenwerking wilt overdragen? Dit is onomkeerbaar.',
    transferSuccess: 'Samenwerking succesvol overgedragen',
    reopenSamenwerking: 'Heropen samenwerking',
    archiveSamenwerking: 'Archiveer samenwerking',
    confirmArchiveSamenwerking: 'Weet je zeker dat je deze samenwerking wilt archiveren? ' +
    'De audit logs worden geëxporteerd naar de gekoppelde zaak en lokale data wordt opgeruimd.',
    aangemaaktDoor: 'Aangemaakt door',
    contactpersoonNaam: 'Contactpersoon',
    startDate: 'Startdatum',
    collaborationForm: 'Samenwerkvorm',
    typeVerzoek: 'Type samenwerking',
    title: 'Titel',
    request: 'Actieverzoek',
    sender: 'Verzender',
    receiver: 'Ontvanger',
    privilegeInitiator: 'Initiator',
    inOrOut: 'In/Uit',
    confidentiality: 'Vertrouwelijkheid',
    documentDescription: 'Documentomschrijving',
    language: 'Taal',
    by: 'Door',
    updated: 'Gewijzigd',
    date: 'Datum',
    type: 'Soort',
    noPartners: 'Nog geen ketenpartners uitgenodigd',
    confirmDeletePartner: 'Weet je zeker dat je deze ketenpartner wilt verwijderen?',
    partner: 'Ketenpartner',
    file: 'Bestand',
    access: 'Toegangsrecht',
    privilegeVT: 'Volledige',
    privilege: 'Beperkt',
    id: 'ID',
    name: 'Naam',
    descriptionCooperation: 'Beschrijving samenwerking',
    purpose: 'Doel samenwerking',
    requestNumber: 'Verzoeknummer',
    phone: 'Telefoonnummer',
    email: 'E-mailadres',
    caseNumber: 'Zaaknummer',
    attachments: 'Bijlagen',
    status: 'Status',
    auditActor: 'Uitgevoerd door',
    auditDescription: 'Beschrijving',
    source: 'Bron',
    sourceZaken: 'Zaken',
    sourceDso: 'DSO',
    synced: 'Sync',
    syncToZaken: 'Ook uploaden naar Zaken',
    notificationType: 'Notificatie type',
    actionType: 'Actie type',
    url: 'URL',
    casetypeUuid: 'Zaaktype',
    fieldMapping: 'Veld mapping',
    caseTarget: 'Zaak maken voor',
    caseTargetSamenwerking: 'Samenwerking',
    caseTargetActieverzoek: 'Actieverzoek',
    relateToCaseSamenwerking: 'Relateer aan samenwerking zaak',
    noteTarget: 'Notitie toevoegen aan',
    noteTargetSamenwerking: 'Samenwerking zaak',
    noteTargetActieverzoek: 'Actieverzoek zaak',
    noteContent: 'Notitie inhoud',
    messageTarget: 'Bericht versturen via',
    messageTargetSamenwerking: 'Samenwerking zaak',
    messageTargetActieverzoek: 'Actieverzoek zaak',
    messageConfig: 'Bericht configuratie',
    messageTo: 'Ontvanger (e-mail)',
    messageSubject: 'Onderwerp',
    messageContent: 'Inhoud',
    syncDocumentInfo: 'Documenten worden automatisch gesynchroniseerd naar de gekoppelde zaak ' +
    'wanneer dit notificatietype binnenkomt.',
    archiveInfo: 'De audit log van de samenwerking wordt geëxporteerd als CSV-bestand en ' +
    'toegevoegd aan de gekoppelde zaak. Na succesvolle upload worden alle logregels van deze ' +
    'samenwerking verwijderd.',
    actieverzoekAuth: 'Actieverzoek authenticatie',
    apiKey: 'API Key',
    interfaceId: 'Interface ID',
    actieverzoekStatuses: 'Uitvoeren bij status',
    requestor: 'Aanvrager',
    requestorType: 'Type aanvrager',
    requestorReference: 'Aanvrager referentie (UUID)',
    sendToUrlConfig: 'URL configuratie',
    sendToUrlUrl: 'URL',
    sendToUrlMethod: 'HTTP methode',
    sendToUrlPayload: 'Payload (JSON)',
    sendToUrlHeaders: 'Headers',
    sendToUrlHeaderValue: 'Waarde',
    sendToUrlAddHeader: 'Header toevoegen',
    ownSystem: 'Eigen systeem',
    automaticSync: 'Automatische sync',
    syncEnabled: 'Synchronisatie ingeschakeld',
    syncDisabled: 'Synchronisatie uitgeschakeld',
    confirmEnableSync: 'Synchronisatie inschakelen',
    confirmDisableSync: 'Synchronisatie uitschakelen',
    confirmEnableSyncText: 'Weet je zeker dat je de automatische synchronisatie wilt inschakelen? ' +
    'Notificaties worden dan periodiek verwerkt.',
    confirmDisableSyncText: 'Weet je zeker dat je de automatische synchronisatie wilt uitschakelen? ' +
    'Notificaties worden dan niet meer automatisch verwerkt.',
    syncNow: 'Sync nu',
    syncNowResult: '%{count} notificatie(s) verwerkt',
  },
  settings: {
    title: 'Instellingen',
    saved: 'Instellingen opgeslagen',
    organizationType: 'Organisatie type',
    notificationSync: 'Notificatie synchronisatie',
    notificationSyncDescription: 'Synchroniseer notificaties van ketenpartners en voer de ' +
    'geconfigureerde acties automatisch uit.',
    notificationSyncHelper: 'Indien ingeschakeld worden notificaties elk uur opgehaald en worden ' +
    'de bijbehorende acties automatisch uitgevoerd.',
    organization: 'Organisatie',
    organizationName: 'Naam',
    organizationOin: 'OIN-nummer',
    organizationAuthId: 'Organisatie ID',
    typeConfig: 'Zaken configuratie',
    urlNoTrailingSlash: 'URL mag niet eindigen met een /',
    zaaksysteem_auth_type: 'Type authenticatie',
    zaaksysteem_url: 'Zaaksysteem URL',
    zs_user_interface: 'Gebruikersinterface',
    zs_user_override: 'Gebruikersnaam',
    authType_api_key: 'API key',
    userInterface_authldap: 'LDAP (authldap)',
    userInterface_samlidp: 'SAML (samlidp)',
  },
  login: {
    title: 'Inloggen',
    button: 'Inloggen',
    choose: 'Kies voor welke organisatie je wilt inloggen:',
    email: 'Email',
    emailHint: 'Vul je emailadres in om door te gaan.',
    fetchUserInfo: 'Een moment geduld, we halen je gebruikersinformatie op.',
    hint: 'Log in op xxllnc Samenwerkingen',
    incognitoError: 'Authenticatie niet mogelijk in incognito mode',
    loginCompleted: 'Succesvol ingelogd!',
    unknownOrganizationId: 'Het opgegeven organisatie-id is onbekend',
    notValid: 'Het opgegeven emailadres is niet geldig',
    byXxllnc: 'Samenwerkingen is een applicatie van xxllnc',
    inactive: 'Je bent uitgelogd vanwege inactiviteit.',
  },
  page: {
    unauthorized: {
      headerTitle: 'Onbevoegd',
      defaultTitle: 'Onbevoegd',
      title: 'Voor deze actie ben je niet bevoegd.',
      text: 'Je hebt geprobeerd een actie uit te voeren waar je geen rechten voor hebt.',
    },
  },
  actions: {
    download: 'Download',
    syncTo: 'Sync naar %{target}',
    deleteFromDso: 'Uit DSO verwijderen',
  },
  verzoekenoverzicht: {
    title: 'Verzoekenoverzicht',
    menuLabel: 'Verzoeken',
    settingsDescription: 'Bekijk DSO-verzoeken die bij uw bevoegd gezag horen.',
    openOverview: 'Naar verzoekenoverzicht',
    startDatum: 'Startdatum',
    eindDatum: 'Einddatum',
    search: 'Zoeken',
    noResults: 'Geen verzoeken gevonden voor de geselecteerde periode',
    backToList: 'Terug naar overzicht',
    detail: {
      general: 'Algemeen',
      plichtType: 'Plichttype',
      activiteiten: 'Activiteiten',
      locatie: 'Locatie',
      notFound: 'Verzoek niet gevonden. Het kan zijn dat dit type verzoek geen details beschikbaar heeft.',
    },
    columns: {
      verzoeknummer: 'Verzoeknummer',
      volgnummer: 'Volgnummer',
      verzoekNaam: 'Naam',
      doelVerzoek: 'Doel',
      verzoekType: 'Type',
      datumIngediend: 'Datum ingediend',
      bevoegdGezag: 'Bevoegd gezag',
      behandeldienst: 'Behandeldienst',
    },
  },
  submenu: {
    settings: 'Beheer',
  },
}
